import { render } from "./NotificationInfoCard.vue?vue&type=template&id=af9312ce&scoped=true"
import script from "./NotificationInfoCard.vue?vue&type=script&lang=js"
export * from "./NotificationInfoCard.vue?vue&type=script&lang=js"

import "./NotificationInfoCard.vue?vue&type=style&index=0&id=af9312ce&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af9312ce"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
